import React from "react";
import {ComparisonOperators, ComparisonSelect} from "../../../../components/CRUDView/Components/ComparisonSelect";
import _ from "lodash";
import {TractorOwnerRequestPaymentStatus} from "../../../../common/Constants";
import moment from "moment";
import {TimeRangeInfo} from "../../../Request/RequestCommon";
import {Badge, Button, Col, FormGroup, InputGroup, InputGroupAddon, Row} from "reactstrap";
import {CustomFilterFrame} from "../../../../components/CRUDView";
import ClearButton from "../../../../components/CRUDView/Components/ClearButton";
import {Async as AsyncSelect, components} from "react-select";
import TwoLineItemRender from "../../../../components/Elements/TwoLineItemRender";

export function PaymentStatusBadge({ payment , onClick }) {

    let content;
    switch (payment.status){
        case TractorOwnerRequestPaymentStatus.Success:
            content = <Badge pill={true} color={"success"}>Successful</Badge>;
            break;
        case TractorOwnerRequestPaymentStatus.Failed:
            content = <Badge pill={true} color={"warning"}>Failed</Badge>;
            break;
        case TractorOwnerRequestPaymentStatus.Cancelled:
            content = <Badge pill={true} color={"danger"}>Cancelled</Badge>;
            break;
    }

    return <h6 onClick={onClick} style={ onClick ? { cursor: "pointer"}  : null }>{content}</h6>;
}

export const PAYOUTS_FILTERS = [
    {
        key: 'orderId',
        filterKey: 'tractor_request.order_id',  // http request filter query key
        operator: '[]',
        query: "request_id",
        apply: true
    },
    {
        key: 'transactionId',
        filterKey: 'local_reference',  // http request filter query key
        operator: '[]',
        query: "transaction_id",
        apply: true
    },
    {
        key: 'externalReference',
        filterKey: 'external_reference',  // http request filter query key
        operator: '[]',
        query: "external_reference",
        apply: true
    },
    {
        key: "accountName",
        filterKey: 'receiver_account_name',
        operator: '[]',
        query: 'account_name',
        apply: true // indicates this filter should be applied to real query
    },
    {
        key: 'accountNo',
        filterKey: 'receiver_account_no',
        operator: '[]',
        query: 'account_detail',
        apply: true // indicates this filter should be applied to real query
    },
    {
        key: "paymentProvider",
        filterKey: "payment_provider",
        operator: '[]',
        query: 'provider',
        apply: true // indicates this filter should be applied to real query
    },
    {
        key: "amount",
        query: "pay_amount",
        operator: filters => filters.amountOperator || "=",
        fromQuery: value => {
            return value !== "" && isFinite(value) ? Number(value)  : undefined;
        },
        apply: true
    },
    {
        key: 'amountOperator',
        query: 'amount_op',
        fromQuery: value => !!ComparisonOperators.find(x => x.symbol) ? value : undefined
    },
    {
        key: 'cost',
        filterKey: "tractor_request.cost",
        query: 'request_cost',
        operator: filters => filters.costOperator || "=",
        apply: true,
        fromQuery: value => isFinite(value) ? Number(value) : undefined
    },
    {
        key: 'costOperator',
        query: 'cost_op',
        fromQuery: value => !!ComparisonOperators.find(x => x.symbol) ? value : undefined
    },

    {
        key: 'payoutOperator',
        query: 'payout_op',
        fromQuery: value => !!ComparisonOperators.find(x => x.symbol) ? value : undefined
    },
    {
        key: 'payout',
        query: 'payout',
        operator: filters => filters.payoutOperator || "=",
        apply: true,
        fromQuery: value => isFinite(value) ? Number(value) : undefined
    },
    {
        key: 'tractorId',
        filterKey: 'tractor_request.tractor_id',
        query: 'tractor_id',
        apply: true
    },
    {
        key: 'tractorName',
        query: '_tractor_select_name'
    },
    {
        key: "tractorOperator",
        filterKey: 'tractor_request.tractor_operator_id',
        query: "tractor_operator",
        apply: true
    },
    {
        key: "tractorOperatorName",
        query: "_operator_select_name"
    },
    {
        key: 'owner_id',
        query: "owner_id",
        apply: true
    },
    {
        key: 'tractorOwnerName',
        query: "_owner_select_name"
    },
    {
        key: 'status',
        name: "Status",
        query: 'payment_status',
        apply: true,
        fromQuery: value => {

            if(isFinite(value))
                return Number(value);

            if(_.isString(value))

                switch (value.toLowerCase()) {
                    case 'success':
                        return  TractorOwnerRequestPaymentStatus.Success;
                    case 'failed':
                        return  TractorOwnerRequestPaymentStatus.Failed;
                    case 'cancelled':
                        return  TractorOwnerRequestPaymentStatus.Cancelled;
                }

        },
        renderValue: value => {

            switch (Number(value)) {
                case TractorOwnerRequestPaymentStatus.Success:
                    return "Success";
                case TractorOwnerRequestPaymentStatus.Failed:
                    return  "Failed";
                case TractorOwnerRequestPaymentStatus.Cancelled:
                    return "Cancelled";
            }
        }
    },
    {
        key: "farmerId",
        filterKey: 'tractor_request.farmer_id',
        query: 'farmer_id',
        apply: true
    },
    {
        key: 'farmerName',
        query: "_farmer_select_name"
    },
    {
        key: "timeFrame",
        query: "_frame",
        name: "Date Range",
        dependencies: [ 'timeRangeStart' , 'timeRangeEnd' ],    //  remove these dependencies when filter chip is deleted
        fromQuery: value => Object.keys(TimeRangeInfo).includes(value) ? value : undefined,
        renderValue: (value,filters) => {

            if(value === "custom"){

                if(filters.timeRangeStart && filters.timeRangeEnd){
                    return `${moment(filters.timeRangeStart).format('L')} - ${moment(filters.timeRangeEnd).format('L')}`;
                }

            }

            return TimeRangeInfo[value].text;
        }
    },
    {
        key: "timeRangeStart",
        query: "_from",
        toQuery: value => !_.isNil(value) &&  moment(value).isValid() ? moment(value).toJSON() : undefined,
        fromQuery: value => {

            let date = moment(value);
            if(!_.isNil(value) && date.isValid())
                return date.toDate();

            return null;
        }
    },
    {
        key: "timeRangeEnd",
        query: "_to",
        toQuery: value => !_.isNil(value) && moment(value).isValid() ? moment(value).toJSON() : undefined,
        fromQuery: value => {

            let date = moment(value);
            if(!_.isNil(value) && date.isValid())
                return date.toDate();

            return null;
        }
    }
];

export const parsePayoutFilters = (filters) => {

    const getSelectOption = (entity,queryKey,filterKey) => {
        const _key = filterKey || `${entity}.id`;
        const _name = filters[queryKey || `${entity}Name`];
        return filters[_key] ? { label: _name , value: filters[_key]  , instance: { id : filters[_key] , name: _name } } : null ;
    };

    return {
        orderId: filters.orderId || '',
        transactionId: filters.transactionId || '',
        accountName: filters.accountName || '',
        accountNo: filters.accountNo || '',
        cost: filters.cost || '',
        costOperator: filters.costOperator || '=',
        amount: filters.amount || '',
        amountOperator: filters.amountOperator|| '=',
        tractor: getSelectOption('tractor',undefined,'tractorId'),
        farmer: getSelectOption('farmer',undefined,'farmerId'),
        commission: filters.commission || '',
        commissionOperator: filters.commissionOperator || '=',
        payout: filters.payout || '',
        payoutOperator: filters.payoutOperator || '=',
        tractorOperator: getSelectOption(undefined, 'tractorOperatorName','tractorOperatorName'),
        owner: getSelectOption(undefined,'tractorOwnerName','owner_id')
    };

};

export const CustomPayoutsFilters = ({   applyFilters ,
                                         toggle ,
                                         values ,
                                         setValue ,
                                         setValues ,
                                         resetValues,
                                         fetchFarmers,
                                         fetchOperators,
                                         fetchTractors,
                                         fetchOwners }) => {

    return <CustomFilterFrame toggle={toggle}>

        <Row>

            <Col md={3}>

                <b>Transaction ID</b>
                <input name="transactionId"
                       value={values['transactionId']}
                       onChange={evt => {
                           setValue('transactionId',evt.target.value);
                       }}
                       type="text"
                       className="form-control form-input-select"
                       placeholder="Transaction reference or ID"/>

            </Col>

            <Col md={3}>

                <b>Request ID</b>
                <input name="orderId"
                       value={values['orderId']}
                       onChange={evt => {
                           setValue('orderId',evt.target.value);
                       }}
                       type="text"
                       className="form-control form-input-select"
                       placeholder="Request order id"/>

            </Col>

            <Col md={3}>

                <b>Amount</b>
                <FormGroup>
                    <InputGroup>


                        <input name="amount"
                               value={values['amount']}
                               onChange={evt => {
                                   setValue('amount',evt.target.value);
                               }}
                               type="number"
                               className="form-control form-input-select"
                               placeholder="Amount paid"/>

                        <InputGroupAddon addonType="prepend">
                            <ComparisonSelect value={values['amountOperator']} onChange={operator => setValue('amountOperator',operator)}/>
                        </InputGroupAddon>

                    </InputGroup>
                </FormGroup>


            </Col>

            <Col md={3}>

                <b>Service Cost</b>
                <FormGroup>
                    <InputGroup>

                        <input name="cost"
                               value={values['cost']}
                               onChange={evt => {
                                   setValue('cost',evt.target.value);
                               }}
                               type="number"
                               className="form-control form-input-select"
                               placeholder="Request cost"/>

                        <InputGroupAddon addonType="prepend">
                            <ComparisonSelect value={values['costOperator']} onChange={operator => setValue('costOperator',operator)}/>
                        </InputGroupAddon>

                    </InputGroup>
                </FormGroup>

            </Col>


            <Col md={3}>

                <b>Commission</b>

                <FormGroup>
                    <InputGroup>

                        <input name="commission"
                               value={values['commission']}
                               onChange={evt => {
                                   setValue('commission',evt.target.value);
                               }}
                               type="number"
                               min={0}
                               className="form-control form-input-select"
                               placeholder="Request commission"/>

                        <InputGroupAddon addonType="prepend">
                            <ComparisonSelect value={values['commissionOperator']} onChange={operator => setValue('commissionOperator',operator)}/>
                        </InputGroupAddon>

                    </InputGroup>
                </FormGroup>

            </Col>

            <Col md={3}>

                <b>Payout</b>

                <FormGroup>
                    <InputGroup>

                        <input name="payout"
                               value={values['payout']}
                               onChange={evt => {
                                   setValue('payout',evt.target.value);
                               }}
                               type="number"
                               min={0}
                               className="form-control form-input-select"
                               placeholder="Request payout amount"/>

                        <InputGroupAddon addonType="prepend">
                            <ComparisonSelect value={values['payoutOperator']} onChange={operator => setValue('payoutOperator',operator)}/>
                        </InputGroupAddon>

                    </InputGroup>
                </FormGroup>


            </Col>

            {fetchTractors && <Col md={3}>

                <div className="clearfix">
                    <b className="pull-left">Tractor</b>
                    <div className="pull-right">
                        <ClearButton onClick={() => setValues({
                            tractor: null,
                            tractorName: null
                        })}/>
                    </div>
                </div>
                <AsyncSelect  name="tractor"
                              defaultOptions
                              cacheOptions
                              placeholder="Select tractor..."
                              value={values['tractor']}
                              onChange={value => {
                                  setValue('tractor',value);
                              }}
                              components={{
                                  Option: ({ children , ...props }) => {

                                      const tractor = props.data.instance;
                                      return <components.Option {...props}>

                                          <TwoLineItemRender media={tractor.media}
                                                             line1Value={`${tractor.name} (${tractor.registration_number})`}
                                                             line2Prefix="Chassis"
                                                             line2Value={tractor.chassis}/>

                                      </components.Option>

                                  }
                              }}
                              loadOptions={async (value) => {

                                  try {

                                      const tractors = await fetchTractors({
                                          search: { keyword: value , method: 'inside', fields: ['name','chassis', 'registration_number' ] },
                                          pagination: { page: 1 , perPage : 5 },
                                          include: [ 'media' ]
                                      });

                                      return tractors.map(t => ({ label: `${t.name} (${t.registration_number})` , value: t.id  , instance: t }));
                                  }
                                  catch (e) {

                                      // failed to load query

                                  }

                              }}/>


            </Col>}

            {fetchOperators && <Col md={3}>

                <div className="clearfix">
                    <b className="pull-left">Tractor Operator</b>
                    <div className="pull-right">
                        <ClearButton onClick={() => setValues({
                            tractorOperator: null,
                            tractorOperatorName: null
                        })}/>
                    </div>
                </div>

                <AsyncSelect  name="tractorOperator"
                              defaultOptions
                              cacheOptions
                              placeholder="Select tractor operator..."
                              value={values['tractorOperator']}
                              onChange={value => {
                                  setValue('tractorOperator',value);
                              }}
                              components={{
                                  Option: ({ children , ...props }) => {

                                      const operator = props.data.instance;
                                      return <components.Option {...props}>

                                          <TwoLineItemRender  media={operator.media}
                                                              line1Value={operator.name}
                                                              line2Prefix="Phone"
                                                              line2Value={operator.phone}/>

                                      </components.Option>

                                  }
                              }}
                              loadOptions={async (value) => {

                                  try {

                                      const operators = await fetchOperators({
                                          search: { keyword: value , method: 'inside', fields: [ 'name' , 'email', 'phone' ] },
                                          pagination: { page: 1 , perPage : 5 },
                                          include: [ 'media']
                                      });

                                      return operators.map(t => ({ label: t.name , value: t.id  , instance: t }));
                                  }
                                  catch (e) {

                                      // failed to load query

                                  }

                              }}/>
            </Col>}

            {fetchOwners && <Col md={3}>

                <div className="clearfix">
                    <b className="pull-left">Tractor Owner</b>
                    <div className="pull-right">
                        <ClearButton onClick={() => setValues({
                            owner: null,
                            tractorOwnerName: null
                        })}/>
                    </div>
                </div>
                <AsyncSelect  name="owner"
                              defaultOptions
                              cacheOptions
                              placeholder="Select tractor owner..."
                              value={values['owner']}
                              onChange={value => {
                                  setValue('owner',value);
                              }}
                              components={{
                                  Option: ({ children , ...props }) => {

                                      const owner = props.data.instance;
                                      return <components.Option {...props}>

                                          <TwoLineItemRender  media={owner.media}
                                                              line1Value={owner.name}
                                                              line2Prefix="Phone"
                                                              line2Value={owner.user.phone}/>

                                      </components.Option>

                                  }
                              }}
                              loadOptions={async (value) => {

                                  try {

                                      const owners = await fetchOwners({
                                          search: { keyword: value , method: 'inside', fields: ['name' , 'user.email', 'user.phone' ] },
                                          pagination: { page: 1 , perPage : 5 },
                                          include: [ 'media' , 'user' ]
                                      });

                                      return owners.map(t => ({ label: t.name , value: t.id  , instance: t }));
                                  }
                                  catch (e) {

                                      // failed to load query

                                  }

                              }}/>

            </Col>}

            <Col md={3}>

                <b>Receiver Account Name</b>
                <input name="accountName"
                       value={values['accountName']}
                       onChange={evt => {
                           setValue('accountName',evt.target.value);
                       }}
                       type="text"
                       className="form-control form-input-select"
                       placeholder="Account name"/>

            </Col>

            <Col md={3}>
                <b>Receiver Account No.</b>
                <input name="accountNo"
                       value={values['accountNo']}
                       onChange={evt => {
                           setValue('accountNo',evt.target.value);
                       }}
                       type="text"
                       className="form-control form-input-select"
                       placeholder="Account no."/>

            </Col>

            {fetchFarmers && <Col md={3}>


                <div className="clearfix">
                    <b className="pull-left">Farmer</b>
                    <div className="pull-right">
                        <ClearButton onClick={() => setValues({
                            farmer: null,
                            farmerName: null
                        })}/>
                    </div>
                </div>
                <AsyncSelect  name="farmer"
                              defaultOptions
                              cacheOptions
                              placeholder="Select farmer..."
                              value={values['farmer']}
                              onChange={value => {
                                  setValue('farmer',value);
                              }}
                              components={{
                                  Option: ({ children , ...props }) => {

                                      const farmer = props.data.instance;
                                      return <components.Option {...props}>

                                          <TwoLineItemRender  media={farmer.media}
                                                              line1Value={farmer.name}
                                                              line2Prefix="Phone"
                                                              line2Value={farmer.phone}/>

                                      </components.Option>

                                  }
                              }}
                              loadOptions={async (value) => {

                                  try {

                                      const farmers = await fetchFarmers({
                                          search: { keyword: value , method: 'inside', fields: ['name' , 'phone' , 'user.email', 'user.phone' ] },
                                          pagination: { page: 1 , perPage : 5 },
                                          include: [ 'media' , 'user' ]
                                      });

                                      return farmers.map(t => ({ label: t.name , value: t.id  , instance: t }));
                                  }
                                  catch (e) {

                                      // failed to load query

                                  }

                              }}/>


            </Col>}

        </Row>


        <hr/>

        <div className="clearfix">

            <div className="pull-left">
                <Button onClick={() => resetValues() }><i className="fa fa-refresh"/> Reset Filters</Button>
            </div>

            <div className="pull-right">
                <Button color="green" style={{ borderRadius: 4 }} onClick={() => {

                    let _targetFilter = { };
                    Object.keys(values).forEach(k => {

                        let _v = values[k];
                        let _initialValue = _v;

                        switch (k) {
                            case "farmer":
                                k = "farmerId";
                                _v = !_.isNil(_v) ? _v.instance.id : null;
                                _targetFilter['farmerName'] = _v ? _initialValue.instance.name : undefined;
                                break;
                            case "tractor":
                                k = "tractorId";
                                _v = !_.isNil(_v) ? _v.instance.id : null;
                                _targetFilter['tractorName'] = _v ? _initialValue.instance.name : undefined;
                                break;
                            case "owner":
                                k = "owner_id";
                                _v = !_.isNil(_v) ? _v.instance.id : null;
                                _targetFilter['tractorOwnerName'] = _v ? _initialValue.instance.name : undefined;
                                break;
                            case "tractorOperator":
                                _v = !_.isNil(_v) ? _v.instance.id : null;
                                _targetFilter['tractorOperatorName'] = _v ? _initialValue.instance.name : undefined;
                                break;

                        }

                        if(!_.isNil(_v) && _v !== ""){
                            _targetFilter[k] = _v;
                        }
                        else{
                            _targetFilter[k] = undefined;
                        }

                    });

                    applyFilters(_targetFilter);


                }}><i className="fa fa-check"/> Apply</Button>
            </div>
        </div>

    </CustomFilterFrame>
};


// WEBPACK FOOTER //
// ./src/views/Extras/Finance/TractorOwnerPayouts/PayoutsCommon.js